"use strict";

import { Box, OutsideClick, Portal } from '@autoguru/overdrive';
import clsx from 'clsx';
import { memo, useLayoutEffect } from 'react';
import * as styles from './Drawer.css';
import { jsx as _jsx } from "react/jsx-runtime";
const isServer = typeof window === 'undefined';

// This component should only ever be mounted on the client.
export const Drawer = /*#__PURE__*/memo(({
  isOpen,
  onRequestClose,
  direction: _direction = 'LEFT_TO_RIGHT',
  fullWidth: _fullWidth = true,
  children,
  className: _className = ''
}) => {
  useLayoutEffect(() => {
    if (!isOpen || isServer) {
      return void 0;
    }
    document.documentElement.style.overflow = 'hidden';
    return () => {
      // @ts-ignore
      document.documentElement.style.overflow = null;
    };
  }, [isOpen]);
  return isServer ? void 0 : /*#__PURE__*/_jsx(Portal, {
    container: document.body,
    children: /*#__PURE__*/_jsx(Box, {
      as: "aside",
      position: "fixed",
      width: "full",
      className: clsx(styles.root, _className, {
        [styles.open]: isOpen,
        [styles.containerRTL]: _direction === 'RIGHT_TO_LEFT',
        [styles.constrained]: !_fullWidth
      }),
      children: /*#__PURE__*/_jsx(OutsideClick, {
        onOutsideClick: () => onRequestClose('overlay'),
        children: /*#__PURE__*/_jsx(Box, {
          as: "main",
          width: "full",
          height: "full",
          backgroundColour: "white",
          boxShadow: isOpen ? '2' : 'none',
          className: clsx(styles.content, _className, {
            [styles.fromLeft]: _direction === 'LEFT_TO_RIGHT',
            [styles.fromRight]: _direction === 'RIGHT_TO_LEFT',
            [styles.open]: isOpen
          }),
          children: children
        })
      })
    })
  });
});